import React, { useState, useEffect, useCallback } from 'react';

import { TextField, TextFieldProps } from '@mui/material';
import { useDebouncedCallback } from 'use-debounce';

function DebounceTextField({ value, onChange, ...other }: TextFieldProps) {
  const [innerValue, setInnerValue] = useState('');

  useEffect(() => {
    if (value) {
      setInnerValue(value as string);
    } else {
      setInnerValue('');
    }
  }, [value]);

  const debouncedHandleOnChange = useDebouncedCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      onChange(event);
    }
  }, 200);

  useEffect(
    () => () => {
      debouncedHandleOnChange.flush();
    },
    [debouncedHandleOnChange],
  );

  const handleOnChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      event.persist();

      const newValue = event.currentTarget.value;

      setInnerValue(newValue);
      debouncedHandleOnChange(event);
    },
    [debouncedHandleOnChange],
  );

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <TextField {...other} value={innerValue} onChange={handleOnChange} />;
}

export default DebounceTextField;
